import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { sendRequest } from '../../hooks/requests/useRequest';
import { validarSesion } from '../../hooks/tokens/useToken';
import { useHistory, useParams } from 'react-router';
import { useForm } from '../../hooks/forms/useForm';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { LostConnection } from '../../constant';
import { useDebounce } from '../debounce/useDebounce';
import { queryAllByAltText } from '@testing-library/react';
import { usePagination } from '../pagination/usePagination';
import { Badge } from 'reactstrap';
import validateNegative  from '../../utils/validations/validationNegativePrice'
import validatePrice  from '../../utils/validations/validationPrice'
import {getAllGroup,createAllgroup,UpdateAllgroup,getListGroup, saveExamOrder } from '../../services/profiles/profilesService'
import { getInformationIndicationsPatient, getInformationIndicationsLaboratory,getByExamPatient,getByExamLaboratory, getByProfileList, getByProfileListLab, saveAndUpdateProfileIndicationsLab,saveAndUpdateProfileIndications } from '../../services/indications/indications';
import { getInformationSection } from '../../services/exams/exams';
import * as XLSX from 'xlsx';




export const useProfiles = () => {


    const history = useHistory();

    const { profilesId, methodd } = useParams();
    console.log("🚀 ~ useProfiles212 ~ profilesId:", profilesId)

    const [profiles, setProfiles] = useState([]);
    // console.log("🚀 ~ useProfiles ~ profiles:", profiles)
    const [method, setMethod] = useState(methodd === undefined ? "" : methodd);


    const [listFirstPrice, setListFirstPrice] = useState([]);

    const [loading, setLoading] = useState(false);
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete] = useSweetAlert();
    const [modalTitle, setModalTitle] = useState("");
    const [modal, setModal] = useState(false);

    //SEARCH PRICE EXAMS 
    const [exam, setExam] = useState([]);
    const [searchPrice, setSearchPrice] = useState([]);

    //DEBOUNCEVALUE % Público
    const [rangeval, setRangeval] = useState(0);
    const debounceValue = useDebounce(rangeval, 3000);

    //DEBOUNCEVALUE % Máquila sin toma 
    const [rangevalM, setRangevalM] = useState(0);
    const debounceValueM = useDebounce(rangevalM, 3000);

    //DEBOUNCEVALUE % Máquila con toma
    const [rangevalMS, setRangevalMS] = useState(0);
    const debounceValueMS = useDebounce(rangevalMS, 3000);

    const [idTest, setIdTest] = useState(0);
    const [index, setIndex] = useState(-1);
    const [indexParent, setIndexParent] = useState(-1);

    const [idTestM, setIdTestM] = useState(0);
    const [indexM, setIndexM] = useState(-1);
    const [indexParentM, setIndexParentM] = useState(-1);

    const [idTestMS, setIdTestMS] = useState(0);
    const [indexMS, setIndexMS] = useState(-1);
    const [indexParentMS, setIndexParentMS] = useState(-1);

    const [totalCommercialLines, setTotalCommercialLines] = useState([]);
    // console.log("🚀 ~ useProfiles ~ totalCommercialLines:", totalCommercialLines)

    //ID PROFILE
    const [profileId, setProfileId] = useState(0)

    //LIST  PRIOFILES TABLE
    const [listProfile, setListProfile] = useState([]);

    //LIST PROFILE COMERCIAL
    const [listCommercial, setListCommercial] = useState([]);

    //MODAL DELETE
    const [modal2, setModal2] = useState(false);

    //MODAL LIST COMMERCIAL LINE
    const [modal3, setModal3] = useState(false);

    const [sendKitSampling, setSendKitSampling] = useState(0);
    const [continueCreation, setContinueCreation] = useState(false);

    //MODAL DE ORDERBYEXAM
    const [methodOrder, setMethodOrder] = useState("");
    const [titleOrder, setTitleOrder] = useState("");
    const [modalOrder, setModalOrder] = useState(false);

    ///COPY PROFILE
    const [totalPublico, setTotalPublico] = useState(0);
    const [totalReferencia, setTotalReferencia] = useState(0);
    const [examsData, setExamsData] = useState([]);


    //Section Exam
    const [modalSectionExam, setModalSectionExam] = useState(false);
    const [titleSectionExam, setTitleSectionExam] = useState("");


    const [modalFormSection, setModalFormSection] = useState(false);
    const [titleFormSection, setTitleFormSection] = useState("");
    const [methodFormSection, setMethodFormSection] = useState("");

    const [profileOrder, setProfileOrder] = useState([]);
    const [visibleOrder, setVisibleOrder] = useState(false);

    //*LIST INDICATIONS
    const [dataIndication, setDataIndication] = useState([])
    const [dataIndicationLab, setDataIndicationLab] = useState([])
    const [searchTerm, setSearchTerm] = useState('');


    //*Order exam
    const [loadingOrder, setLoadingOrder] = useState(false);

    // ? Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    const [nameError, setNameError] = useState("");
    const [abbreviationError, setAbbreviationError] = useState("");
    const [codeError, setCodeError] = useState("");

    const [deleteExamData, setDeleteExamData] = useState({
        id_profile_exam: null,
        id_exam: null,
        name_exam: ""
    });

    console.log("🚀 ~ useProfiles ~ profileOrder:", profileOrder)

    const toggle = () => {
        setModal(!modal);
    }


    const toggle2 = () => {
        setModal2(!modal2)

    }

    const toggle3 = () => {
        setModal3(!modal3)

    }

       
    const openDeleteAlert = (rowData) => {
        setDeleteExamData({
            id_profile_exam: rowData.id_profile_exam,
            id_exam: rowData.id_exam,
            name_exam: rowData.name_exam
        });

        setShowDeleteAlert(true);
        setModalAlert(true);
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false);
        setModalAlert(false);

        setDeleteExamData({
            id_profile_exam: null,
            id_exam: null,
            name_exam: ""
        });
    };

    //MODAL IMAGENOLOGIA

    const toggleOrderByExam = () => {
        setModalOrder(!modalOrder);
    }


    const toggleSectionExam = () => {
        console.log("toggleSectionExam ejecutado");
        setModalSectionExam(!modalSectionExam);
    }


    const toggleFormSection = () => {
        setModalFormSection(!modalFormSection);
    }
    useEffect(() => {

        getProfiles();

    }, [history.location]);


    useEffect(() => {
        if (rangeval) {

            if (index !== -1) {

                let copySearchPrice = searchPrice;
                // ////console.log(copySearchPrice);

                let price = copySearchPrice[indexParent].exams[index].price;
                copySearchPrice[indexParent].exams[index].percentage = rangeval;

                let percentagePrice = ((price * rangeval) / 100);

                let total = price - percentagePrice;
                // ////console.log(total);

                copySearchPrice[indexParent].exams[index].total = total;

                setSearchPrice([...copySearchPrice]);
                //calcularPorcentajeDescuento();
            }
        }
    }, [debounceValue])


    useEffect(() => {
        if (rangevalM) {

            if (indexM !== -1) {

                let copySearchPrice = searchPrice;

                let price = copySearchPrice[indexParentM].exams[indexM].price;
                copySearchPrice[indexParentM].exams[indexM].percentage_with_toma = rangevalM;

                let percentagePrice = ((price * rangevalM) / 100);

                let total_with_toma = price - percentagePrice;

                copySearchPrice[indexParentM].exams[indexM].total_with_toma = total_with_toma;

                setSearchPrice([...copySearchPrice]);
            }
        }
    }, [debounceValueM])



    useEffect(() => {
        if (rangevalMS) {

            if (indexMS !== -1) {

                let copySearchPrice = searchPrice;

                let price = copySearchPrice[indexParentMS].exams[indexMS].price;
                copySearchPrice[indexParentMS].exams[indexMS].percentage_without_toma = rangevalMS;

                let percentagePrice = ((price * rangevalMS) / 100);

                let total_without_toma = price - percentagePrice;

                copySearchPrice[indexParentMS].exams[indexMS].total_without_toma = total_without_toma;

                setSearchPrice([...copySearchPrice]);
            }
        }
    }, [debounceValueMS])


    useEffect(() => {



        if (profilesId !== undefined) {
            prueba(profilesId);
            getListPriceByProfile(profilesId);
            getProfileGroup(profilesId)
        }

    }, [profilesId])


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        name: "",
        abbreviation: "",
        code: "",
        is_critic: false,
        is_curve: false,
        id_profile: 0,
        sampling_cost: 0,
        porcentaje: 0,
        is_micro: false,
        individual_saleP: false,
        id_section: "",
        delivery_time: "",

    });

    const { name, abbreviation, code, profileExam, id_commercial_line, exams, id_exam, is_critic, is_curve, id_profile, sampling_cost, porcentaje, is_micro, individual_saleP, id_section, delivery_time } = formValues;
    // console.log("🚀 ~ useProfiles ~ id_profile:", id_profile)

    // console.log(formValues);

    const [validationsProfile, setValidationsProfile] = useState({
        nameValid: false,
        abbreviationValid: false,
        codeValid: false,

    });
    ///diseno/nuevo-perfil/:methodd`

    const navigateUpdate = () => {
        history.push(`../diseno/nuevo-perfil/create`);
    }


    const navigateUpdateP = (profileId) => {
        // console.log(profileId);
        history.push(`../diseno/${profileId}/editar-perfil/update`);
    }

    const navigateCosts = (profileId) => {
        history.push(`../diseno/${profileId}/costs`);
    }

    const navigateGlobal = (profileId) => {
        history.push(`../diseno/${profileId}/global`);
    }

    useEffect(() => {

        if (searchPrice.length >= 1) {

            let copy = totalCommercialLines;

            if (copy.length >= 1) {

                copy.forEach(obj => {
                    // console.log("aaaaaaaaaaaaaaaaaaaa");
                    // console.log(obj);

                    let id_commercial_line = obj.id_commercial_line;
                    let id_rate = obj.id_rate;
                    // console.log(id_rate);

                    let find = searchPrice.find(x => x.id_rate == id_rate);
                    // console.log(find);


                    if (find) {
                        // console.log("que llevas");

                        let sum = 0;
                        let sumPublico = 0;
                        let sumP = 0;
                        let sumTp = 0;
                        let sumTsM = 0;
                        let min = Infinity;
                        let max = 0;
                        let minimoPrecio = 0;


                        find.exams.forEach(o => {
                            sum += (o.total + o.total_with_toma + o.total_without_toma);
                            sumPublico += o.price
                            sumP += o.total
                            sumTp += o.total_without_toma
                            sumTsM += o.total_with_toma
                            minimoPrecio += o.production_price

                            if (sum > 0 && min > sum)
                                min = sum

                            if (sum > 0 && max < sum)
                                max = sum;

                        });
                        obj.total = sum
                        obj.total_venta_publico_general = sumPublico;
                        obj.descuento_Publico = sumP;
                        obj.descuento_Maquila_sin_toma = sumTp;
                        obj.descuento_Maquila_con_toma = sumTsM;
                        obj.minimoProduccion = minimoPrecio;

                        obj.minn = min;
                        obj.maxx = max;
                        if (!Number.isFinite(min)) {
                            min = 0
                        }
                    }
                    setTotalCommercialLines([...copy])

                });
            }
            else {
                searchPrice.forEach(obj => {
                    // console.log("bbbbbbbbbbbbbbbbbbb");
                    console.log(obj);
                    let id_commercial_line = obj.id_rate;
                    let ttotal = 0;
                    let ttotalPublico = 0;
                    let ssumP = 0;
                    let ssumTp = 0;
                    let ssumTsM = 0;
                    let min = Infinity;
                    let max = 0;
                    let minimoPrecio = 0;
                    let id_rate = obj.id_rate;



                    obj.exams.forEach(o => {
                        ttotal += (o.total + o.total_with_toma + o.total_without_toma);
                        ttotalPublico += (o.price)
                        ssumP += o.total
                        ssumTp += o.total_without_toma
                        ssumTsM += o.total_with_toma
                        minimoPrecio += o.production_price


                        if (ttotal > 0 && min > ttotal)
                            min = ttotal

                        if (ttotal > 0 && max < ttotal)
                            max = ttotal;

                    });
                    if (!Number.isFinite(min)) {
                        min = 0
                    }
                    copy.push({
                        id_commercial_line: id_rate,
                        name: obj.name_commercial_line,
                        color_commercial_line: obj.color_commercial_line,
                        total: ttotal,
                        total_venta_publico_general: ttotalPublico,
                        descuento_Publico: ssumP,
                        descuento_Maquila_sin_toma: ssumTp,
                        descuento_Maquila_con_toma: ssumTsM,
                        minn: min,
                        maxx: max,
                        minimoProduccion: minimoPrecio,
                        id_rate: id_rate,
                        name_rate: obj.name_rate,



                    })
                    setTotalCommercialLines([...copy]);

                });
            }
        }
        else {
            let mArray = [];
            searchPrice.forEach(obj => {

                console.log("ccccccccccccccccccccccccc");

                console.log(obj);
                let id_commercial_line = obj.id_commercial_line;
                let ttotal = 0;
                let ttotalPublico = 0;
                let ssumP = 0;
                let ssumTp = 0;
                let ssumTsM = 0;
                let min = Infinity;
                let max = 0;
                let id_rate = obj.id_rate;


                obj.exams.forEach(o => {
                    ttotal += (o.total + o.total_with_toma + o.total_without_toma);
                    ttotalPublico += obj.price
                    ssumP += o.total
                    ssumTp += o.total_without_toma
                    ssumTsM += o.total_with_toma

                    if (ttotal > 0 && min > ttotal)
                        min = ttotal

                    if (ttotal > 0 && max < ttotal)
                        max = ttotal;

                });

                if (!Number.isFinite(min)) {
                    min = 0
                }

                mArray.push({
                    id_commercial_line: id_commercial_line,
                    name: obj.name_commercial_line,
                    color_commercial_line: obj.color_commercial_line,
                    total: ttotal,
                    total_venta_publico_general: ttotalPublico,
                    descuento_Publico: ssumP,
                    descuento_Maquila_sin_toma: ssumTp,
                    descuento_Maquila_con_toma: ssumTsM,
                    minn: min,
                    maxx: max,
                    id_rate: id_rate,
                    name_rate: obj.name_rate,
                })

                setTotalCommercialLines([...mArray])
            });
        }

    }, [searchPrice])

    const [updateProfile, setUpdateProfile] = useState([])


    const prueba = async (profilesId) => {
        let requestOptions = {
            method: 'GET',
        };
        let car = true
        const respuesta = await sendRequest(requestOptions, `Profiles/ListDetailProfile/${profilesId}`);

        // console.log(respuesta);
        if (respuesta.code == 200) {

            setUpdateProfile(respuesta.data)
            handleUpdateValues({
                name: respuesta.data.name,
                abbreviation: respuesta.data.abbreviation,
                code: respuesta.data.code,
                is_critic: respuesta.data.is_critic,
                is_curve: respuesta.data.is_curve,
                id_profile: respuesta.data.id_profile,
                sampling_cost: respuesta.data.sampling_cost,
                porcentaje: 0,
                is_micro: respuesta.data.is_micro,
                individual_saleP: respuesta.data.individual_saleP,
                id_section: respuesta.data.id_section,
                delivery_time: respuesta.data.delivery_time

                // REGRESAR
            });

            setSearchPrice([
                ...respuesta.data.listProfileCommercialLines
            ]);

        }
    }

    const getListPriceByProfile = async (profile_id) => {

        let requestOptions = {
            method: 'GET'
        }

        const respuesta = await sendRequest(requestOptions, `Profiles/getPriceFromRates/${profile_id}`);
        // console.log(respuesta);
        console.log("🚀 ~ getListPriceByProfile ~ respuesta:", respuesta)
        // console.log("que lleva aqui");

        if (respuesta.code === 200) {
            setListFirstPrice(respuesta.data);
        }

    }

    const [dataSeleccionado, setDataSeleccionado] = useState({});

    const handleChange = (e, id_exam, idParent, idChildren) => {
        // handleInputChange(e)
        setDataSeleccionado({
            e, id_exam, idParent, idChildren
        });

        setIdTest(id_exam)

        setIndex(idChildren)

        setIndexParent(idParent)

        setRangeval(e.target.value)


        let copySearchPrice = searchPrice;

        copySearchPrice[idParent].exams[idChildren].percentage = e.target.value;

        let price = copySearchPrice[idParent].exams[idChildren].price;

        let percentagePrice = ((price * parseFloat(e.target.value)) / 100);

        let total = price - percentagePrice;

        copySearchPrice[idParent].exams[idChildren].total = total;

        setSearchPrice([...copySearchPrice]);
    }


    const handleChangeSinToma = (e, id_exam, idParent, idChildren) => {

        setIdTestMS(id_exam)

        setIndexMS(idChildren)

        setIndexParentMS(idParent)

        setRangevalMS(e.target.value)

        let copySearchPrice = searchPrice;

        copySearchPrice[idParent].exams[idChildren].percentage_without_toma = e.target.value;

        let price = copySearchPrice[idParent].exams[idChildren].price;

        let percentagePrice = ((price * parseFloat(e.target.value)) / 100);

        let total_without_toma = price - percentagePrice;

        copySearchPrice[idParent].exams[idChildren].total_without_toma = total_without_toma;

        setSearchPrice([...copySearchPrice]);
    }

    const handleChangeConToma = (e, id_exam, idParent, idChildren) => {

        setIdTestM(id_exam)

        setIndexM(idChildren)

        setIndexParentM(idParent)

        setRangevalM(e.target.value)

        let copySearchPrice = searchPrice;

        copySearchPrice[idParent].exams[idChildren].percentage_with_toma = e.target.value;

        let price = copySearchPrice[idParent].exams[idChildren].price;

        let percentagePrice = ((price * parseFloat(e.target.value)) / 100);

        let total_with_toma = price - percentagePrice;

        copySearchPrice[idParent].exams[idChildren].total_with_toma = total_with_toma;

        setSearchPrice([...copySearchPrice]);

    }

    const handleChangeExam = (e) => {
        handleInputChange(e)

        let examProfile = e.target.value;

        if (examProfile !== 0 && examProfile !== null) {

            examProfile = examProfile.split("-");

            let mIdExam = examProfile[0];
            let mTipo = examProfile[1];

            if (mTipo === "1") {
                createSweet("error", "error", "No se pueden agregar perfiles ");
            }
            else {
                getPriceExam(mIdExam)
            }
        }
    }

    const getPriceExam = async (mIdExam) => {

        let requestOptions = {
            method: 'GET'
        };

        let listPriceExams = searchPrice;
        let listSum = totalCommercialLines;

        const respuesta = await sendRequest(requestOptions, "TabPriceExam/SearchPriceExam/" + mIdExam);
        // console.log("🚀 ~ getPriceExam ~ respuesta:", respuesta)

        if (respuesta.code === 200) {

            if (respuesta.data.length >= 1) {

                respuesta.data.forEach((value) => {

                    let _validate_price = "";
                    let _price_null = ""

                    _price_null = validatePrice(value.price)
                    if (_price_null === "true" || _price_null) {
                        createSweett("Estudios", `No se puede agregar el estudio ${value.name_exam} sin precio , favor de verificarlo en el tarifario.`, "error");
                        return;
                    }
                    _validate_price = validateNegative(value.price)

                    if (_validate_price === "true" || _validate_price) {
                        createSweett("Estudios", `No se puede agregar el estudio ${value.name_exam} con precio negativo de  ${value.price}.`, "error");
                        return;
                    }


                    if (listPriceExams.length === 0) {

                        listPriceExams.push({
                            id_commercial_line: value.id_commercial_line,
                            name_commercial_line: value.name_commercial_line,
                            color_commercial_line: value.color_commercial_line,
                            name_rate: value.name_rate,
                            id_rate: value.id_rate,


                            exams: [
                                {
                                    id_exam: value.id_exam,
                                    name_exam: value.name_exam,
                                    code_exam: value.code_exam,
                                    id_price: value.id_price,
                                    price: value.price,
                                    percentage: 0,
                                    total: value.price,
                                    production_price: value.production_price,
                                    alertClass: "",
                                    max: 0,
                                    percentage_without_toma: 0,
                                    total_without_toma: value.price,
                                    percentage_with_toma: 0,
                                    total_with_toma: value.price,
                                    totales: listSum
                                }
                            ]
                        })
                    }
                    else {

                        // console.log(listPriceExams);

                        let findCommercialLine = listPriceExams.find(c => c.id_rate == value.id_rate);
                        // console.log(findCommercialLine);
                        let findIndexCommercialLine = listPriceExams.findIndex(c => c.id_rate == value.id_rate);
                        // console.log(findIndexCommercialLine);


                        if (findCommercialLine) {

                            let findExam = findCommercialLine.exams.find(e => e.id_exam == value.id_exam)
                            // console.log(findExam);
                            if (!findExam) {

                                findCommercialLine.exams.push({
                                    id_exam: value.id_exam,
                                    name_exam: value.name_exam,
                                    code_exam: value.code_exam,
                                    id_price: value.id_price,
                                    price: value.price,
                                    percentage: 0,
                                    total: value.price,
                                    production_price: value.production_price,
                                    alertClass: "",
                                    max: 0,
                                    percentage_without_toma: 0,
                                    total_without_toma: value.price,
                                    percentage_with_toma: 0,
                                    total_with_toma: value.price,
                                    totales: listSum
                                })
                                listPriceExams[findIndexCommercialLine] = findCommercialLine;
                            }
                        }
                        else {

                            // console.log("aqui entro");

                            listPriceExams.push({
                                id_commercial_line: value.id_commercial_line,
                                name_commercial_line: value.name_commercial_line,
                                color_commercial_line: value.color_commercial_line,
                                name_rate: value.name_rate,
                                id_rate: value.id_rate,


                                exams: [
                                    {
                                        id_exam: value.id_exam,
                                        name_exam: value.name_exam,
                                        code_exam: value.code_exam,
                                        id_price: value.id_price,
                                        price: value.price,
                                        percentage: 0,
                                        total: value.price,
                                        production_price: value.production_price,
                                        alertClass: "",
                                        max: 0,
                                        percentage_without_toma: 0,
                                        total_without_toma: value.price,
                                        percentage_with_toma: 0,
                                        total_with_toma: value.price,
                                        totales: listSum
                                    }
                                ]
                            })
                        }
                    }
                });
                setSearchPrice([...listPriceExams]);
                changeOrder();
            }

            else {
                createSweet("error", "error", "Hubo un error!", "Sin información");
            }
        }
        else if (respuesta.code === 409) {
            createSweet("warning", "warning", "Aviso", respuesta.data.msg);

        }
        else {
            createSweet("error", "error", "Hubo un error!", LostConnection);
            validarSesion(history, respuesta.code, getPriceExam);
        }
    }

    const getProfiles = async () => {

        let requestOptions = {
            method: 'GET',
        };

        let ListProfiles = [];


        const respuesta = await sendRequest(requestOptions, "Profiles");
        if (respuesta.code === 200) {

            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;


            endItems = aux;
            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {

                respuesta.data.forEach((element, index) => {
                    console.log("🚀 ~ respuesta.data.forEach ~ respuesta:", respuesta)
                    // console.log("🚀 ~ respuesta.data.forEach ~ element:", element)
                    let indiceE = element.profileExams.length

                    let min = Infinity;
                    let max = 0;

                    element.priceProfileViewModel.forEach(sucursal => {

                        if (sucursal.price > 0 && min > sucursal.price)
                            min = sucursal.price;

                        if (sucursal.price > 0 && max < sucursal.price)
                            max = sucursal.price;
                    });

                    if (!Number.isFinite(min)) {
                        min = 0
                    }

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    ListProfiles.push({
                        id_profile: element.id_profile,
                        name: element.name,
                        abbreviation: element.abbreviation,
                        code: element.code,
                        is_critic: element.is_critic,
                        profileExams: element.profileExams,
                        priceProfileViewModel: element.priceProfileViewModel,
                        labelExa: element.labelExa !== null ? <Badge color={element?.is_micro ? "success" : 'primary' ?? "primary"} pill>{indiceE}&nbsp;Exámenes</Badge> : "",
                        labelExas: element.labelExas !== null ? <Badge color={element?.is_micro ? "success" : 'primary' ?? "primary"} pill> ${min.toFixed(2)} -  ${max.toFixed(2)}</Badge> : "",
                        is_micro: element.is_micro,
                        id_section: element.id_section,
                        delivery_time: element.delivery_time,
                        visibleTable: visibleTable
                    })
                });
                setProfiles(ListProfiles);
                setProfilesData(ListProfiles);
                setListProfiles(ListProfiles)
            }
        }
        else {
            validarSesion(history, respuesta.code, getProfiles);
        }
    }

    const saveCreate = async () => {
        if (validarProfile()) {
            setLoading(false);
            return;
        }
            setLoading(true); 



        let body = {
            name: formValues.name,
            abbreviation: formValues.abbreviation,
            code: formValues.code,
            is_critic: formValues.is_critic,
            is_curve: formValues.is_curve,
            profileExam: searchPrice,
            is_micro: formValues.is_micro,
            individual_saleP: formValues.individual_saleP ? 1 : 0,
            id_section: formValues.id_section ? formValues.id_section : null,
            ids_profiles: (Array.isArray(formValues.id_exam) && formValues.id_exam.length > 0) ? formValues.id_exam : null,
            delivery_time: formValues.delivery_time

        };

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        };

        try {
            const respuesta = await sendRequest(requestOptions, "Profiles");

            if (respuesta.code === 200) {
                setLoading(false);
                createSweet("success", "success", "Se creó correctamente el perfil");
                handleUpdateValues({
                    searchPrice: [],
                    name: "",
                    abbreviation: " ",
                    code: " ",
                    is_critic: false,
                    is_curve: false,
                    is_micro: false,
                    id_section: "",
                    delivery_time: "",
                });
                setTimeout(() => {
                    window.location.href = `${process.env.PUBLIC_URL}/diseno/perfiles`
                }, 1000);
                setSendKitSampling(respuesta.data.id_profile);
            } else {
                setLoading(false);
                createSweet("error", "warning", "Examen", respuesta.data?.msg || "Error desconocido");
            }
        } catch (error) {
            setLoading(false);
            console.error("Error en la solicitud:", error);
            createSweet("error", "warning", "Examen", "Hubo un error en la solicitud.");
        }
    };


    const handleListProfile = (id_profile) => {

        let profile = profiles.find(a => a.id_profile === parseInt(id_profile));

        ////console.log(profile);

        if (profile != null) {
            if (profile.profileExams.length >= 1) {
                setListProfile(profile.profileExams)
            }
            else {
                setListProfile([]);
            }

            setMethod("list");
            setModalTitle("Examenes");
            toggle();

        }
        else {
            setListProfile([]);
            createSweet("error", "error", "No se encontraron los datos seleccionados");
        }
    }


    const handleListComercial = (id_profile) => {

        let profile = profiles.find(a => a.id_profile === parseInt(id_profile));

        if (profile != null) {
            if (profile.priceProfileViewModel.length >= 1) {
                setListCommercial(profile.priceProfileViewModel)
            }
            else {
                setListCommercial([]);
            }
            setMethod("list");
            setModalTitle("Precios");
            toggle3();
        }
        else {
            setListCommercial([]);
            createSweet("error", "error", "No se encontraron los datos seleccionados");
        }
    }

    const handleDelete = (id_profile) => {

        let profile = profiles.find(a => a.id_profile === parseInt(id_profile));

        handleUpdateValues({
            abbreviation: profile.abbreviation,
            code: profile.code,
            name: profile.name
        });

        setProfileId(id_profile)
        setMethod("delete");
        setModalTitle("Eliminar perfil");
        toggle2();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };
        const respuesta = await sendRequest(requestOptions, `Profiles/${profileId}`);

        if (respuesta.code === 200) {
            getProfiles();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Perfil Eliminado");
            toggle2();
        }
        else {
            createSweet("error", "error", "Hubo un error!", LostConnection);
            setLoading(false);
            validarSesion(history, respuesta.code, saveDelete);
        }
    }

    const saveUpdate = async () => {
        if (validarProfile()) {
            setLoading(false);
            return;
        }

        setLoading(true);
        console.log("form3", updateProfile);

        let body = {

            id_profile: profilesId,
            name: formValues.name,
            abbreviation: formValues.abbreviation,
            code: formValues.code,
            is_critic: formValues.is_critic,
            is_curve: formValues.is_curve,
            profileExam: searchPrice,
            is_micro: formValues.is_micro,
            id_section: formValues.id_section ? formValues.id_section : null,
            individual_saleP: formValues.individual_saleP,
            delivery_time: formValues.delivery_time


        }

        console.log(body);

        let requestOptions = {
            method: 'PUT',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "Profiles");

        if (respuesta.code === 200) {

            createSweet("create", "info", "Exito!", "Examenes Actualizados");

            handleUpdateValues({
                searchPrice: [],
                name: "",
                abbreviation: " ",
                code: " ",
                is_critic: false,
                is_curve: false,
                sampling_cost: sampling_cost,
                is_micro: false,
                individual_saleP: false,
                id_section: "",
                delivery_time: "",
            });
            history.goBack()

        }
        else {
            setLoading(false);
            createSweet("error", "error", "Hubo un error!");
        }
    }

    const handleDeleteExamGlobal = async (id_profile_exam, id_exam) => {
        const examId = Number(id_exam);

        if (id_profile_exam === undefined || id_profile_exam === null) {
            const newSearchPrice = searchPrice
                .map(group => {

                    return {
                        ...group,

                        exams: (group.exams || []).filter(
                            exam => Number(exam.id_exam) !== examId
                        )
                    };

                })
                .filter(group => group.exams && group.exams.length > 0);

            setSearchPrice(newSearchPrice);

            handleUpdateValues({
                ...formValues,
                searchPrice: newSearchPrice
            });

            return;
        }

        try {

            const requestOptions = {
                method: 'DELETE'
            };

            const respuesta = await sendRequest(
                requestOptions,
                `Profiles/Delete/${profilesId},${id_profile_exam}`
            );


            if (respuesta.code === 200) {

                const newSearchPrice = searchPrice
                    .map(group => {

                        return {
                            ...group,

                            exams: (group.exams || []).filter(
                                exam => Number(exam.id_exam) !== examId
                            )
                        };

                    })
                    .filter(
                        group =>
                            group.exams &&
                            group.exams.length > 0
                    );

                setSearchPrice(newSearchPrice);

                handleUpdateValues({
                    ...formValues,
                    searchPrice: newSearchPrice
                });


                createSweet( "success", "success", "Se elimino correctamente el exámen");
            }

            else if (respuesta.code === 401) {
                validarSesion(
                    history,
                    respuesta.code,
                    () =>
                        handleDeleteExamGlobal(
                            id_profile_exam,
                            id_exam
                        )
                );

            }
            else {
                createSweet(
                    "warning",
                    "warning",
                    "Exámenes",
                    respuesta.data?.msg ||
                    "No se pudo eliminar el examen"
                );

            }

        }
        catch (error) {
            createSweet( "error","error", "Exámenes","Ocurrió un problema al eliminar el examen");
        }
    };

    const saveDeleteExamProfile = async () => {
        if (!deleteExamData.id_exam) {
            return;
        }

        await handleDeleteExamGlobal(
            deleteExamData.id_profile_exam,
            deleteExamData.id_exam
        );

        closeDeleteAlert();
    };

    const validarProfile = () => {

        let statusValidation = false;
        let newValidations = {};

        const profileName = formValues.name ?? "";
        const profileAbbreviation = formValues.abbreviation ?? "";
        const profileCode = formValues.code ?? "";

        // Name
        if (profileName.trim() === "") {
            setNameError("El nombre del perfil es obligatorio");
            newValidations.nameValid = true;
            statusValidation = true;
        }
        else if (profileName !== profileName.trim()) {
            setNameError("El nombre no puede tener espacios al inicio ni al final");
            newValidations.nameValid = true;
            statusValidation = true;
        }
        else if (profileName.length < 3) {
            setNameError("El nombre debe tener 3 o más caracteres");
            newValidations.nameValid = true;
            statusValidation = true;
        }
        else {
            setNameError("");
            newValidations.nameValid = false;
        }


        // Abreviatyure
        if (profileAbbreviation.trim() === "") {
            setAbbreviationError("La abreviatura es obligatoria");
            newValidations.abbreviationValid = true;
            statusValidation = true;
        }
        else if (profileAbbreviation !== profileAbbreviation.trim()) {
            setAbbreviationError("La abreviatura no puede tener espacios al inicio ni al final");
            newValidations.abbreviationValid = true;
            statusValidation = true;
        }
        else if (profileAbbreviation.length < 3) {
            setAbbreviationError("La abreviatura debe tener 3 o más caracteres");
            newValidations.abbreviationValid = true;
            statusValidation = true;
        }
        else {
            setAbbreviationError("");
            newValidations.abbreviationValid = false;
        }


        // CLave
        if (profileCode.trim() === "") {
            setCodeError("La clave del perfil es obligatoria");
            newValidations.codeValid = true;
            statusValidation = true;
        }
        else if (profileCode !== profileCode.trim()) {
            setCodeError("La clave no puede tener espacios al inicio ni al final");
            newValidations.codeValid = true;
            statusValidation = true;
        }
        else {
            setCodeError("");
            newValidations.codeValid = false;
        }

        setValidationsProfile(newValidations);

        return statusValidation;

    }

    const changeContinueCreation = () => {
        setContinueCreation(!continueCreation);
    }

    useEffect(() => {
        if (continueCreation) {
            history.goBack();
        }
    }, [continueCreation])

    const numberItems = 10;

    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(profiles.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listProfiles = [];
        profiles.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listProfiles.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setProfiles(listProfiles);

    }, [totalPageCount, currentPage]);

    const [profilesData, setProfilesData] = useState([]);
    const [listProfiles, setListProfiles] = useState([]);

    const handleSearchProfile = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        profilesData.forEach(element => {
            //////console.log(element);
            let cadena = element.name.toUpperCase();
            let abbreviation = element.abbreviation.toUpperCase();
            let code = element.code.toUpperCase();

            if ((cadena.indexOf(busqueda.toUpperCase()) > -1) || (abbreviation.indexOf(busqueda.toUpperCase()) > -1) || (code.indexOf(busqueda.toUpperCase()) > -1)) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setProfiles(newMethod);
    }

    const handleOrderByExam = () => {

        toggleOrderByExam();
        setMethodOrder("OrderBy")
        setTitleOrder("Ordenar Exámenes");
        changeOrder();
    }


    const handleSectionExam = () => {
        console.log("handleSectionExam ejecutado");
        toggleSectionExam();
        setTitleSectionExam("Secciones para Exámenes");
        changeOrder();
    }

    const handleFormSection = () => {
        toggleFormSection();
        setMethodFormSection("create");
        setTitleFormSection("Agregar sección");
    }





    const [data, setData] = useState([]);

    const changeOrder = () => {

        let copy = searchPrice;

        ////console.log("Se ejecuta despues de cargar los perfiles", copy);

        let arrayExams = [];

        copy.forEach(element => {

            let arrExams = element.exams;

            arrExams.forEach(e => {
                if (arrayExams.length > 0) {
                    let findExam = arrayExams.find(x => x.id_exam === parseInt(e.id_exam));

                    if (!findExam) {
                        arrayExams.push({
                            id_exam: e.id_exam,
                            title: e.name_exam
                        });
                    }
                }
                else {
                    arrayExams.push({
                        id_exam: e.id_exam,
                        title: e.name_exam
                    });
                }
            });
        });
        const ordered = arrayExams.sort((a, b) => {
            const posA = selectedSections1.find(x => x.id_exam === a.id_exam)?.position ?? Number.MAX_SAFE_INTEGER;
            const posB = selectedSections1.find(x => x.id_exam === b.id_exam)?.position ?? Number.MAX_SAFE_INTEGER;

            return posA - posB;
        });

        setData([...ordered]);
        // setData(ordered);
        setData([...arrayExams]);
    }
    console.log("🚀 ~ useProfiles ~ data:", data)




    const cambiar = (info) => {
        setData(info);
    }

    const handleSaveOrderExamsAnalyte = async (orderData) => {

        if (orderData.length === 0) return;

        setLoadingOrder(true);

        try {

            let tmpExams = [...searchPrice];

            tmpExams.forEach(element => {

                let arrExams = element.exams;
                let tmpArrayExams = [];

                orderData.forEach((e, i) => {

                    let findExam = arrExams.find(x => x.id_exam === parseInt(e.id_exam));

                    if (findExam) {
                        tmpArrayExams.push({
                            ...findExam,
                            order: i + 1
                        });
                    }
                });

                element.exams = tmpArrayExams;
            });

            const result = {
                id_profile: parseInt(profilesId),
                exams: orderData.map((item, index) => ({
                    id_exam: item.id_exam,
                    order: index + 1
                }))
            };

            const response = await saveExamOrder(result);

            if (response.code === 200) {

                setSearchPrice(tmpExams);

                await getProfileGroup(profilesId);

                changeOrder();

                createSweet(
                    "success",
                    "success",
                    "Se guardó correctamente el orden"
                );

                toggleOrderByExam();

            } else {

                createSweet(
                    "warning",
                    "warning",
                    response?.data?.message ?? "No fue posible guardar el orden"
                );
            }

        } catch (error) {

            console.error(error);

            createSweet(
                "error",
                "Error",
                "Ocurrió un error al guardar el orden"
            );

        } finally {

            setLoadingOrder(false);

        }
    };

    const [findRate, setFindRate] = useState(null);




    const [resul, setResul] = useState(0);
    const [idrate, setIdrate] = useState(null)


    function calcularPorcentajeDescuento(precioTotal, precioDeseado, llave) {
        console.log(precioTotal, precioDeseado);

        const array = searchPrice;
        const pTotal = parseFloat(precioTotal || 0);
        const pDeseado = parseFloat(precioDeseado || 0);

        if (pDeseado <= 0) {
            console.warn("Precio deseado no válido.");
            return 0;
        }

        let porcentaje = 0;

        try {
            if (pTotal > 0) {
                porcentaje = ((pTotal - pDeseado) / pTotal) * 100;
                porcentaje = Math.floor(porcentaje * 100) / 100; // redondear a 2 decimales
            }

            console.log("Porcentaje:", porcentaje);
            setResul(porcentaje);

            const updated = array.map(element => {
                if (element.id_rate === llave || element.id_rate === idrate) {
                    element.price_profile = pDeseado;

                    try {
                        const newExams = element.exams.map(exam => {
                            const porcentajePrecio = (exam.price * porcentaje) / 100;
                            const totalConToma = exam.price - porcentajePrecio;

                            return {
                                ...exam,
                                percentage: porcentaje,
                                total: totalConToma
                            };
                        });

                        element.exams = newExams;
                    } catch (error) {
                        console.error("Error procesando exams:", error);
                    }
                }

                return element;
            });

            console.log("Resultado final:", updated);
            setSearchPrice([...updated]);
            togglePrice();
        } catch (error) {
            console.error("Error en calcularPorcentajeDescuento:", error);
            return 0;
        }
    }

    //#region modalChart

    const [titlePrice, setTitlePrice] = useState("");
    const [typeprice, setTypeprice] = useState("viewPrices");
    const [modalPrice, setModalPrice] = useState(false);
    const [typepriceProfile, setTypepricePrice] = useState("viewPricesProfile");

    const [modalPriceProfile, setModalPriceProfile] = useState(false);


    const [llavecard, setLlavecard] = useState("");
    const [arrayExams, setArrayExams] = useState([]);
    console.log("🚀 ~ useProfiles ~ arrayExams:", arrayExams)





    const togglePrice = () => {
        setModalPrice(!modalPrice)
    }

    const togglePriceProfile = () => {
        setModalPriceProfile(!modalPriceProfile)
    }



    const handleprices = (keyNim, array, _llave) => {
        console.log(keyNim);
        console.log(array);
        console.log(_llave);

        setTypeprice("viewPrices");
        setTitlePrice("Precio");
        setLlavecard(keyNim);
        setArrayExams(array);
        setIdrate(_llave)
        togglePrice();
        handleUpdateValues({
            ...formValues,
            porcentaje: 0,

        })

    }





    //#endregion modalChart

    //#region Copy Profiles



    const searchProfiles = async (inputValue, url) => {
        if (inputValue.length < 3) return [];

        const response = await fetch(`/api/${url}?query=${inputValue}&simple_profile=true`);
        const data = await response.json();

        return data.map(profile => ({
            value: profile.id_component,
            label: profile.component
        }));
    };



    const handleChangeProfile = (e) => {
        handleInputChange(e)

        let Profile = e.target.value;

        if (Profile !== "1" && Profile !== null) {

            Profile = Profile.split("-");

            let mIdExam = Profile[0];
            let mTipo = Profile[1];

            if (mTipo === "0") {
                createSweet("error", "error", "No se pueden agregar examenes ");
            }
            else {
                // getProfileExams(mIdExam)
            }
        }
    }


    const getProfileExams = async (exam) => {
        setLoading(true);

        let requestOptions = {
            method: 'GET',
        };

        const response = await sendRequest(requestOptions, `Profiles/GetProfileExams/${exam}`);

        if (response.code === 200) {

            let listPriceExams = searchPrice;
            console.log("🚀 ~ getProfileExams ~ listPriceExams:", listPriceExams)


            let listSum = totalCommercialLines;

            response.data.forEach(values => {

                values.forEach(value => {
                    if (listPriceExams.length === 0) {

                        listPriceExams.push({
                            id_commercial_line: value.id_commercial_line,
                            name_commercial_line: value.name_commercial_line,
                            color_commercial_line: value.color_commercial_line,
                            name_rate: value.name_rate,
                            id_rate: value.id_rate,


                            exams: [
                                {
                                    id_exam: value.id_exam,
                                    name_exam: value.name_exam,
                                    code_exam: value.code_exam,
                                    id_price: value.id_price,
                                    price: value.price,
                                    percentage: 0,
                                    total: value.price,
                                    production_price: value.production_price,
                                    alertClass: "",
                                    max: 0,
                                    percentage_without_toma: 0,
                                    total_without_toma: value.price,
                                    percentage_with_toma: 0,
                                    total_with_toma: value.price,
                                    totales: listSum
                                }
                            ]
                        })
                    }
                    else {

                        // console.log(listPriceExams);

                        let findCommercialLine = listPriceExams.find(c => c.id_rate == value.id_rate);
                        // console.log(findCommercialLine);
                        let findIndexCommercialLine = listPriceExams.findIndex(c => c.id_rate == value.id_rate);
                        // console.log(findIndexCommercialLine);


                        if (findCommercialLine) {

                            let findExam = findCommercialLine.exams.find(e => e.id_exam == value.id_exam)
                            // console.log(findExam);
                            if (!findExam) {

                                findCommercialLine.exams.push({
                                    id_exam: value.id_exam,
                                    name_exam: value.name_exam,
                                    code_exam: value.code_exam,
                                    id_price: value.id_price,
                                    price: value.price,
                                    percentage: 0,
                                    total: value.price,
                                    production_price: value.production_price,
                                    alertClass: "",
                                    max: 0,
                                    percentage_without_toma: 0,
                                    total_without_toma: value.price,
                                    percentage_with_toma: 0,
                                    total_with_toma: value.price,
                                    totales: listSum
                                })
                                listPriceExams[findIndexCommercialLine] = findCommercialLine;
                            }
                        }
                        else {

                            // console.log("aqui entro");

                            listPriceExams.push({
                                id_commercial_line: value.id_commercial_line,
                                name_commercial_line: value.name_commercial_line,
                                color_commercial_line: value.color_commercial_line,
                                name_rate: value.name_rate,
                                id_rate: value.id_rate,


                                exams: [
                                    {
                                        id_exam: value.id_exam,
                                        name_exam: value.name_exam,
                                        code_exam: value.code_exam,
                                        id_price: value.id_price,
                                        price: value.price,
                                        percentage: 0,
                                        total: value.price,
                                        production_price: value.production_price,
                                        alertClass: "",
                                        max: 0,
                                        percentage_without_toma: 0,
                                        total_without_toma: value.price,
                                        percentage_with_toma: 0,
                                        total_with_toma: value.price,
                                        totales: listSum
                                    }
                                ]
                            })
                        }
                    }

                });




            });

            setSearchPrice([...listPriceExams]);
            changeOrder();




        } else {
            createSweet("error", "error", "Hubo un error!", "Sin información");
        }

    };

    console.log("🚀 ~ getProfileExams ~ searchPrice:", searchPrice)
    console.log("🚀 ~ getProfileExams ~ totalCommercialLines:", totalCommercialLines)



    // useEffect(() => {
    //     if (!examsData || examsData.length === 0) return;

    //     const totalPublico = examsData
    //         .flat()
    //         .filter(item => item.name_rate === "PUBLICO GENERAL") 
    //         .reduce((acc, item) => acc + (item.price || 0), 0);

    //     const totalReferencia = examsData
    //         .flat()
    //         .filter(item => item.name_rate === "SERVICIO DE REFERENCIA")
    //         .reduce((acc, item) => acc + (item.price || 0), 0);


    //     setTotalPublico(totalPublico);
    //     setTotalReferencia(totalReferencia);
    // }, [examsData]);


    const handlePricesProfile = (keyNim, array, _llave) => {
        setTypepricePrice("viewPricesProfile");
        setTitlePrice("Precio");
        setLlavecard(keyNim);
        setArrayExams(array);
        setIdrate(_llave)
        togglePrice();
        handleUpdateValues({
            ...formValues,

        })

    }

    const [discounts, setDiscounts] = useState(examsData.map(() => 0));

    const handleDiscountChange = (index, value) => {
        const newDiscount = [...discounts];
        newDiscount[index] = value;
        setDiscounts(newDiscount);
    };

    //#endregion 

    useEffect(() => {
        getSections()

    }, [])

    // ? CONFIGURATION PROFILE GROUP
    const [sections, setSections] = useState([]);
    const [valueGroup, setValueGroup] = useState("");
    const [selectedSections, setSelectedSections] = useState([]);
    const [selectedSections1, setSelectedSections1] = useState([]);
    const [sectionsProfile, setSectionsProfile] = useState([]);



    const getSections = async () => {
        const listGroup = await getAllGroup();

        if (listGroup.code === 200) {
            const list = listGroup.data?.map(_groups => {
                return {
                    value: _groups?.id_profile_group,
                    label: _groups?.name,
                    position: _groups?.position
                }
            });
            setSections(list);
        }
        else setSections([]);
    }


    const handleChangeGroup = (e) => {
        setValueGroup(e.target.value);
    };


    const handleSectionChange = (examId, e) => {
        const newValue = e.target.value;
        setSelectedSections((prevState) => ({
            ...prevState,
            [examId]: newValue,
        }));
    };

    const handleDeleteSelection = (examId) => {
        setSelectedSections1((prevState) => {
            const newSelectedSections1 = prevState.filter(item => item.id_exam !== examId);
            return newSelectedSections1;
        });
    };


    const saveSamplingPlan = async (_valueGroup) => {
        if (_valueGroup === "") {
            createSweet("error", "error", "Bloque", "Debe escribir el nombre un grupo");
            return;
        }

        const response = await createAllgroup({ name: _valueGroup });

        if (response.code === 200) {
            createSweet("success", "success", "Bloque de exámenes", "Se han guardado correctamente los datos");
            toggleFormSection();
            setValueGroup("");
            getSections();
        }
        else {
            createSweet("wanirnig", "warning", response?.data?.message);
            setValueGroup("");
        }
    }

    const saveGroup = async () => {
        const updatedAssignations = selectedSections1.map(item => {
            const selectedGroup = selectedSections[item.id_exam];
            return {
                id_exam: item.id_exam,
                id_profile_group: selectedGroup ? parseInt(selectedGroup) : item.id_profile_group
            };
        });

        const result = {
            id_profile: profilesId,
            assignations: updatedAssignations
        };


        const response = await UpdateAllgroup(result, profilesId);

        if (response.code === 200) {
            createSweet("success", "success", "Bloque de exámenes", "Se ha guardado correctamente los cambios del bloque del exámen");
            toggleSectionExam();
        } else {
            createSweet("warning", "warning", response?.data?.message);
        }
    };

    // const saveGroup = async () => 
    // {
    //     console.log("🚀 ~ assignations:Object.keys ~ selectedSections:", selectedSections)

    //     const result = {
    //         id_profile: profilesId,
    //         assignations: Object.keys(selectedSections).map(key => ({
    //             id_exam: parseInt(key),
    //             id_profile_group: parseInt(selectedSections[key]) 
    //         }))
    //     };
    //     console.log("🚀 ~ useProfiles ~ result:", result)

    //     const response = await UpdateAllgroup(result,profilesId);

    //     if (response.code === 200) {
    //         createSweet("success", "success", "Bloque de exámenes", "Se ha guardado correctamente los cambios del bloque del exámen");
    //         toggleSectionExam()
    //     }
    //     else {
    //          createSweet("wanirnig", "warning", response?.data?.message);
    //     }         
    // }


    const getProfileGroup = async (_id_profile) => {

        const listGroup = await getListGroup(_id_profile);

        if (listGroup.code === 200) {

            const list = listGroup.data?.map(_groups => {

                return {
                    id_exam: _groups?.id_exam,
                    name_exam: _groups?.name_exam,
                    id_profile_group: _groups?.id_profile_group
                };
            });
            setSelectedSections1(list)
        }
    };

    //#region Order Analytes
    const handleOrderByProfile = async () => {
        setLoading(true);
        listOrderProfiles(profilesId);
        console.log("Modal abierto");
        setVisibleOrder(true);
        setLoading(false);
    };

    // #endregion


    // #region Order Profiles

    const listOrderProfiles = async (id_profile) => {
        const requestOptions = {
            method: 'GET',
        };

        const response = await sendRequest(requestOptions, `ProfileGroup/ListOrder/${id_profile}`);

        if (response.code === 200 && Array.isArray(response.data)) {
            const orderedItems = response.data.map(item => ({
                id: item.id,
                content: item.content,
                subItems: item.subItems?.map(sub => ({
                    id: sub.id,
                    content: sub.content
                })) || []
            }));

            console.log("Orden de perfiles:", orderedItems);

            setProfileOrder(orderedItems);
        } else {
            createSweet("error", "error", "Hubo un error!", "Sin información");
        }
    };

    //#endregion 


    // #region Save Order list profiles

    const saveOrderProfiles = async (id_profile) => {
        setLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(profileOrder),
        };

        const response = await sendRequest(requestOptions, `ProfileGroup/SaveOrder/${id_profile}`);

        if (response.code === 200) {
            createSweet("success", "success", "Actualizado", "El orden fue actualizado correctamente");
            setProfileOrder(profileOrder);
            setData(profileOrder);

            setVisibleOrder(false);

            listOrderProfiles(profilesId);
        } else {
            createSweet("error", "error", "Hubo un error!", "Sin información");
        }
    };


    //#endregion


    // #region Indications profiles
    const [visibleDialog, setVisibleDialog] = useState(false);

    //*INDICATIONS
    const [formIndication, handleInputChangeIndication, resetIndication, handleUpdateValuesIndication, handleSelectValuesIndication] = useForm({
        listIndication: [],
    });

    const { indication, id_profile_indication, listIndication } = formIndication;

    //*INDICATIONS
    const [formIndication2, handleInputChangeIndication2, resetIndication2, handleUpdateValuesIndication2, handleSelectValuesIndication2] = useForm({
        listIndicationLab: [],
    });

    const { listIndicationLab } = formIndication2;




    // ? CATALOG PATIENT

    const handleSaveAllIndications = async (e) => {
        e.preventDefault();
        setLoading(true);



        const selectedIndications = listIndication.map(item => item.value);
        const selectedLabIndications = listIndicationLab.map(item => item.value);

        const responseNormal = await saveAndUpdateProfileIndications(profileId, selectedIndications);
        const responseLab = await saveAndUpdateProfileIndicationsLab(profileId, selectedLabIndications);

        if (responseNormal?.code === 200 && responseLab?.code === 200) {

            createSweet("create", "success", "¡Éxito!", "Indicaciones guardadas correctamente");
            setVisibleDialog(false);

        }
        else if (responseNormal?.code === 401 || responseLab?.code === 401) {

            validarSesion(history, 401);

        }
        else if (responseNormal?.code === 400 || responseLab?.code === 400) {

            createSweet("error", "warning", "Indicaciones", "Solicitud incorrecta");

        }
        else if (responseNormal?.code === 500 || responseLab?.code === 500) {

            createSweet("error", "error", "Indicaciones", "Ocurrió un problema en el servidor");

        }
        else {

            createSweet("error", "warning", "Indicaciones", responseNormal?.data?.msg || responseLab?.data?.msg || "Error al guardar las indicaciones"
            );

        }


        setLoading(false);

    };


    const getExamIndicationSelect = async () => {
        const indications = await getInformationIndicationsPatient();

        if (indications?.length > 0) {
            const list = indications?.map(_find => {
                return {
                    value: _find?.id_exam_indication,
                    label: _find?.indication,
                }
            });
            setDataIndication(list);
        }
        else setDataIndication([]);
    }

    // ? CATALOG LABORATORY
    const getExamIndicationlABSelect = async () => {
        const indications = await getInformationIndicationsLaboratory();

        if (indications?.length > 0) {
            const list = indications?.map(_find => {
                return {
                    value: _find?.id_exam_laboratory_indication,
                    label: _find?.indication,
                }
            });
            setDataIndicationLab(list);
        }
        else setDataIndicationLab([]);
    }

    const getListIndicationsByProfile = async (id_profile) => {
        const information = await getByProfileList(id_profile);

        if (information?.length > 0) {
            const list = information.map(_find => ({
                value: _find?.id_exam_indication,
                label: _find?.indication,
            }));
            handleUpdateValuesIndication({
                ...formIndication,
                listIndication: [...list]
            });
        } else {
            handleUpdateValuesIndication({
                ...formIndication,
                listIndication: []
            });
        }
    };

    const getListIndicationsLabByProfile = async (id_profile) => {
        const informationLab = await getByProfileListLab(id_profile);

        if (informationLab?.length > 0) {
            const list = informationLab.map(_find => ({
                value: _find?.id_exam_laboratory_indication,
                label: _find?.indication,
            }));
            handleUpdateValuesIndication2({
                ...formIndication2,
                listIndicationLab: [...list]
            });
        } else {
            handleUpdateValuesIndication2({
                ...formIndication2,
                listIndicationLab: []
            });
        }
    };


    useEffect(() => {

        getExamIndicationSelect();
        getExamIndicationlABSelect();

    }, [history.location]);



    const handleListProfiles = (id_profile) => {
        setProfileId(id_profile);
        getListIndicationsByProfile(id_profile);
        getListIndicationsLabByProfile(id_profile)
        setVisibleDialog(true);
    };

    const getSectionsProfile = async () => {
        const Nsection = await getInformationSection();

        if (Nsection.code === 200 && Array.isArray(Nsection.data)) {
            const options = Nsection.data.map((section) => ({
                label: section.name,
                value: section.id_section
            }));
            setSectionsProfile(options);
        }
    };


    useEffect(() => {

        getSectionsProfile();

    }, [history.location]);



    //#endregion
    const exportToExcel = () => {
        if (!searchPrice || !searchPrice.length) {
            alert("No hay datos para exportar");
            return;
        }

        const aoa = [
            ['Nombre del Perfil', 'Abreviación', 'Código', 'Tarifario', 'Precio Perfil', 'Código Examen', 'Nombre del Examen', 'Precio de venta al público', 'Precio Final']
        ];

        const groupedData = {};
        searchPrice.forEach(rate => {
            const key = rate.name_rate;

            if (!groupedData[key]) {
                groupedData[key] = {
                    'Rate': rate.name_rate,
                    'Precio Perfil': rate.price_profile,
                    'Exámenes': rate.exams.map(e => e.name_exam),
                    'Código Exámenes': rate.exams.map(e => e.code_exam),
                    'Precio de venta al público': rate.exams.map(e => e.price),
                    'Precio Final': rate.exams.map(e => e.total),
                };
            }
        });

        const merges = [];
        let currentRow = 1;

        Object.values(groupedData).forEach(item => {
            const exams = item['Exámenes'];
            const codes = item['Código Exámenes'];
            const prices = item['Precio de venta al público'];
            const totals = item['Precio Final'];

            exams.forEach((exam, index) => {
                aoa.push([
                    index === 0 ? formValues.name : '',
                    index === 0 ? formValues.abbreviation : '',
                    index === 0 ? formValues.code : '',
                    index === 0 ? item['Rate'] : '',
                    index === 0 ? item['Precio Perfil'] : '',
                    codes[index],
                    exam,
                    prices[index],
                    totals[index]
                ]);
            });

            if (exams.length > 1) {
                merges.push(
                    { s: { r: currentRow, c: 0 }, e: { r: currentRow + exams.length - 1, c: 0 } },
                    { s: { r: currentRow, c: 1 }, e: { r: currentRow + exams.length - 1, c: 1 } },
                    { s: { r: currentRow, c: 2 }, e: { r: currentRow + exams.length - 1, c: 2 } },
                    { s: { r: currentRow, c: 3 }, e: { r: currentRow + exams.length - 1, c: 3 } },
                    { s: { r: currentRow, c: 4 }, e: { r: currentRow + exams.length - 1, c: 4 } }
                );
            }

            currentRow += exams.length;
        });

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        worksheet['!merges'] = merges;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Perfil');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = `${formValues.name || 'Perfil'}.xlsx`;

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const profileIndications = async (profiles) => {
        const enriched = await Promise.all(
            profiles.map(async (profile) => {
                const patient = await getByProfileList(profile.id_profile);
                const lab = await getByProfileListLab(profile.id_profile);

                return {
                    ...profile,
                    patient_indications: patient?.map(p => p.indication) || [],
                    lab_indications: lab?.map(l => l.indication) || []
                };
            })
        );

        return enriched;
    };

    const exportProfilesToExcel = async (profiles) => {

        if (!profiles || !profiles.length) {
            alert("No hay perfiles para exportar");
            return;
        }

        setLoading(true);

        try {

            const enrichedProfiles = await profileIndications(profiles);

            const allTarifarios = new Set();

            enrichedProfiles.forEach((profile) => {
                (profile.priceProfileViewModel || []).forEach((t) =>
                    allTarifarios.add(t.rate_name)
                );
            });

            const tarifariosArray = Array.from(allTarifarios);

            const header = [
                "#",
                "Código",
                "Abreviación",
                "Nombre del Perfil",
                "Nombre del Examen",
                "Indicaciones Paciente",
                "Indicaciones Laboratorio",
                ...tarifariosArray
            ];

            const aoa = [header];
            const merges = [];

            let currentRow = 1;
            let profileNumber = 1;

            enrichedProfiles.forEach((profile) => {

                const {
                    code,
                    name,
                    abbreviation,
                    priceProfileViewModel,
                    profileExams,
                    patient_indications,
                    lab_indications
                } = profile;

                // 🔹 FORMATO LISTA CON VIÑETAS
                const patientText = (patient_indications || [])
                    .map(i => `• ${i}`)
                    .join("\r\n");

                const labText = (lab_indications || [])
                    .map(i => `• ${i}`)
                    .join("\r\n");

                const examenes =
                    profileExams && profileExams.length
                        ? profileExams
                        : [{ name: "" }];

                const nRows = examenes.length;

                examenes.forEach((exam, index) => {

                    const row = [];

                    row.push(
                        profileNumber,
                        code,
                        abbreviation,
                        name,
                        exam.name || "",
                        patientText,
                        labText
                    );

                    tarifariosArray.forEach((tName) => {
                        const tarifa = (priceProfileViewModel || []).find(
                            (t) => t.rate_name === tName
                        );
                        row.push(index === 0 ? (tarifa ? tarifa.price : "") : "");
                    });

                    aoa.push(row);
                });

                // 🔹 MERGE COLUMNAS
                if (nRows > 1) {
                    const colsToMerge = [
                        0, // #
                        1, // Código
                        2, // Abreviación
                        3, // Nombre Perfil
                        5, // Indicaciones Paciente
                        6, // Indicaciones Laboratorio
                        ...tarifariosArray.map((_, idx) => idx + 7)
                    ];

                    colsToMerge.forEach((col) => {
                        merges.push({
                            s: { r: currentRow, c: col },
                            e: { r: currentRow + nRows - 1, c: col },
                        });
                    });
                }

                currentRow += nRows;
                profileNumber++;
            });

            const worksheet = XLSX.utils.aoa_to_sheet(aoa);
            worksheet["!merges"] = merges;

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Perfiles");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
                cellStyles: true
            });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Perfiles.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error exportando perfiles:", error);
            alert("Ocurrió un error al exportar.");
        }

        setLoading(false);
    };

    return {
        //FORMVALUES
        name, abbreviation, code, profileExam, id_commercial_line, exams, id_exam, is_critic, is_curve, profiles, sampling_cost, delivery_time,
        handleInputChange, handleSelectValues,
        //  handleCreate,
        exam, searchPrice, handleChangeExam,
        //DEBOUNCE % EXAM
        handleChange, rangeval, index, idTest,
        // price,
        saveCreate, handleDeleteExamGlobal, navigateUpdate, totalCommercialLines,
        //UPDATE EXAM
        saveUpdate, id_profile,
        //profilesList
        handleListProfile, listProfile, modal, toggle, modalTitle, method,
        //DELETE PROFILE
        handleDelete, saveDelete, toggle2, modal2,
        //update
        navigateUpdateP,
        //profile list commercial
        handleListComercial, toggle3, listCommercial, modal3,
        //VALIDATIONS
        validationsProfile,
        handleChangeSinToma, handleChangeConToma,
        navigateCosts,
        idTestM, idTestMS, indexM, indexMS, rangevalM, rangevalMS,
        sendKitSampling, continueCreation, changeContinueCreation, id_profile,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,
        handleSearchProfile,
        listFirstPrice,
        //OrderByExam
        handleOrderByExam, toggleOrderByExam, methodOrder, titleOrder, modalOrder,
        data, changeOrder, cambiar, handleSaveOrderExamsAnalyte,
        //modal Prices
        titlePrice, typeprice, handleprices, togglePrice, modalPrice, calcularPorcentajeDescuento, resul, porcentaje, handleInputChange, arrayExams, llavecard,
        setFindRate, findRate,
        //Global
        navigateGlobal,

        // ? CONFIGURATION MICRO
        is_micro,

        // ? Copy Profiles
        // query, setQuery

        profileId, setProfileId, getProfileExams, searchProfiles, handleChangeProfile, examsData,
        totalPublico, totalReferencia, handlePricesProfile, togglePriceProfile, handleDiscountChange, discounts,

        // ? section examn
        handleSectionExam, modalSectionExam, toggleSectionExam, titleSectionExam,
        handleFormSection, modalFormSection, toggleFormSection, titleFormSection, methodFormSection, sections, saveSamplingPlan,
        valueGroup, handleChangeGroup, selectedSections, handleSectionChange, saveGroup, selectedSections1,
        handleDeleteSelection, profilesId,


        // ? Order Analyte
        handleOrderByProfile, listOrderProfiles, saveOrderProfiles, profileOrder, setProfileOrder, visibleOrder, setVisibleOrder,

        individual_saleP,


        // ? Profiles Indications
        visibleDialog, setVisibleDialog,
        handleSelectValuesIndication, handleSelectValuesIndication2, dataIndication, dataIndicationLab, getListIndicationsByProfile,
        handleListProfiles, listIndication, listIndicationLab, handleSaveAllIndications, id_section, sectionsProfile, getSectionsProfile, exportToExcel,
        searchTerm, setSearchTerm, exportProfilesToExcel,

        //? ORDER EXAM
        loadingOrder,

        //? ALERT DELETE
        saveDeleteExamProfile,
        modalAlert,
        showDeleteAlert,
        deleteExamData,
        openDeleteAlert,
        closeDeleteAlert, 
        nameError,
        abbreviationError,
        codeError,

    }
}